/**
 * @Desc navigator.userAgent 魔法校APP标识
 * @params {MSAPPAssistant} 老师端APP
 * @params {MSAPPStudent} 家长端APP
 * @params {MSAPP} 魔法校APP
 */
export function isMsApp () {
  let u = navigator.userAgent
  return u.indexOf('MSAPP') > -1
}

export const isPc = () => {
  const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

export default function platform () {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isIOS) {
    return 'ios'
  }
  if (isAndroid) {
    return 'android'
  }
  return 'DS'
}
